import { T } from "./exports";
import { mkParamRow } from "./Makers";
import { IB } from "./UIHelper";

export function ParamRowsEditor({ params = [], onChange, allInputVars = [], method = "GET", showTypeToggle = true, addLabel = "+ Add Param", presetButtons = [] }) {
  const add = () => onChange([...params, { ...mkParamRow(), type: method === "GET" ? "query" : "body" }]);
  const addPreset = (row) => onChange([...params, { ...mkParamRow(), ...row }]);
  const del = (id) => onChange(params.filter(p => p.id !== id));
  const upd = (id, k, v) => onChange(params.map(p => p.id === id ? { ...p, [k]: v } : p));

  const queryRows = params.filter(p => p.type === "query");
  const bodyRows  = params.filter(p => p.type === "body");

  const rowStyle = (typeColor) => ({
    display: "grid",
    gridTemplateColumns: showTypeToggle ? "52px 1fr 68px 1fr 14px" : "1fr 68px 1fr 14px",
    gap: 3,
    marginBottom: 3,
    alignItems: "center",
  });

  const renderRow = (p) => (
    <div key={p.id} style={rowStyle(p.type === "query" ? T.blue : T.green)}>
      {showTypeToggle && (
        <select
          value={p.type}
          onChange={e => upd(p.id, "type", e.target.value)}
          style={{
            ...IB,
            padding: "2px 3px",
            fontSize: 9,
            color: p.type === "query" ? T.blueLt : T.green,
            background: p.type === "query" ? "#0f1f3d" : "#0d2420",
            border: `1px solid ${p.type === "query" ? T.blue+"44" : T.green+"44"}`,
          }}
        >
          <option value="query">Query</option>
          <option value="body">Body</option>
        </select>
      )}
      <input
        value={p.key}
        placeholder="key"
        onChange={e => upd(p.id, "key", e.target.value)}
        style={{ ...IB, fontSize: 10 }}
      />
      <select
        value={p.source}
        onChange={e => upd(p.id, "source", e.target.value)}
        style={{ ...IB, padding: "2px 3px", fontSize: 9 }}
      >
        <option value="literal">Literal</option>
        <option value="variable">Variable</option>
      </select>
      {p.source === "variable" ? (
        <select
          value={p.varName || ""}
          onChange={e => upd(p.id, "varName", e.target.value)}
          style={{ ...IB, padding: "2px 3px", fontSize: 10, color: T.blue }}
        >
          <option value="">— var —</option>
          {allInputVars.map(v => (
            <option key={v.varName} value={v.varName}>${v.varName}</option>
          ))}
        </select>
      ) : (
        <input
          value={p.literalValue || ""}
          placeholder="value"
          onChange={e => upd(p.id, "literalValue", e.target.value)}
          style={{ ...IB, fontSize: 10 }}
        />
      )}
      <button onClick={() => del(p.id)} style={{ background: "none", border: "none", color: T.red, cursor: "pointer", fontSize: 10, padding: 0 }}>✕</button>
    </div>
  );

  return (
    <div style={{ marginBottom: 6 }}>
      {/* Column headers */}
      {params.length > 0 && (
        <div style={{
          display: "grid",
          gridTemplateColumns: showTypeToggle ? "52px 1fr 68px 1fr 14px" : "1fr 68px 1fr 14px",
          gap: 3,
          marginBottom: 3,
          paddingBottom: 2,
          borderBottom: `1px solid ${T.textMute}33`,
        }}>
          {showTypeToggle && <span style={{ fontSize: 7, color: T.textMute, textTransform: "uppercase" }}>Type</span>}
          <span style={{ fontSize: 7, color: T.textMute, textTransform: "uppercase" }}>Key</span>
          <span style={{ fontSize: 7, color: T.textMute, textTransform: "uppercase" }}>Source</span>
          <span style={{ fontSize: 7, color: T.textMute, textTransform: "uppercase" }}>Value / Var</span>
          <span />
        </div>
      )}

      {/* Query params grouped */}
      {showTypeToggle && queryRows.length > 0 && (
        <div style={{ marginBottom: 2 }}>
          <div style={{ fontSize: 7, color: T.blueLt, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 3 }}>
            ↗ Query params (appended to URL)
          </div>
          {queryRows.map(renderRow)}
        </div>
      )}

      {/* Body params grouped */}
      {showTypeToggle && bodyRows.length > 0 && (
        <div style={{ marginBottom: 2 }}>
          <div style={{ fontSize: 7, color: T.green, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 3 }}>
            ✦ Body fields (sent as JSON body)
          </div>
          {bodyRows.map(renderRow)}
        </div>
      )}

      {/* When showTypeToggle is false just render all */}
      {!showTypeToggle && params.map(renderRow)}

      <div style={{ display: "flex", gap: 3, marginTop: 2 }}>
        <button
          onClick={add}
          style={{ flex: 1, fontSize: 8, color: T.blue, background: "none", border: `1px dashed ${T.border}`, borderRadius: 3, padding: "2px 6px", cursor: "pointer" }}
        >
          {addLabel}
        </button>
        {presetButtons.map((pb) => (
          <button
            key={pb.label}
            onClick={() => addPreset(pb.row)}
            style={{ flex: 1, fontSize: 8, color: T.green, background: "none", border: `1px dashed ${T.green}55`, borderRadius: 3, padding: "2px 6px", cursor: "pointer" }}
          >
            {pb.label}
          </button>
        ))}
      </div>
    </div>
  );
}